import React, { Component } from "react";
import { Input as InputAntd } from "antd";

String.prototype.replaceAll = function () {
  let result = "";
  for (let i = 0; i < this.length; i++) {
    if (this[i] !== "," && this[i] !== ".") result += this[i];
  }
  return result;
};

export class InputNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : 0,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      if (this.props.percent) {
        this.setState({ value: newProps.value });
        return;
      }
      if (newProps.value) {
        let finalValue = newProps.value
          .toString()
          .replace(/[^\w\s]/gi, "")
          .trim();
        if (this.props.normal) {
          this.setState({ value: finalValue });
        } else if (this.props.is_money) {
          const final = finalValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.setState({ value: final });
        } else {
          this.setState({ value: finalValue });
        }
      } else {
        this.setState({ value: 0 });
      }
    }
  }

  onChange = (e) => {
    const values = this.props.record;
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if (value === "" || value == "0") {
      this.props.onChange && this.props.onChange(0);
      return this.setState({ value: 0 });
    }

    if (this.props.is_km) {
      if (this.props.is_self_drive) {
        this.props.autoFillKm(this.props.is_km, value);
      }
    }

    if (this.props.percent) {
      if (!isNaN(value)) {
        let finalValue =
          value.startsWith("0") && !value.includes(".")
            ? value.substr(1, value.length - 1)
            : value;
        const convertNumber = finalValue;
        this.props.onChange && this.props.onChange(convertNumber);
      }

      return;
    }
    if (reg.test(value.replaceAll())) {
      let finalValue = value.startsWith("0")
        ? value
            .substr(1, value.length - 1)
            .replace(/[^\w\s]/gi, "")
            .trim()
        : value.replace(/[^\w\s]/gi, "").trim();
      if (this.props.is_money) {
        finalValue = finalValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      if (this.props.maxNumber) {
        if (Number(finalValue) > this.props.maxNumber) {
          this.setState({ value: this.props.maxNumber });
          this.props.onChange &&
            this.props.onChange(Number(this.props.maxNumber));
          return;
        }
      }
      this.setState({ value: finalValue });
      this.props.onChange &&
        this.props.onChange(Number(finalValue.replaceAll()));
    }
  };

  render() {
    const { value } = this.state;
    return (
      <InputAntd
        {...this.props}
        onChange={this.onChange}
        value={value}
        maxLength={14}
      />
    );
  }
}
